/* Site-Specific JavaScript */
jq(document).ready(function () {

    const pathname = window.location.pathname;
    jq('.module-quick-links a').each(function () {
        if (this.getAttribute('href') === pathname) {
            this.parentElement.classList.add('active');
            this.setAttribute('aria-current', 'page');
        }
    })

    jq('[id^=ir-sec-all]').change();
    
    // INTEGRATED SHADOW DOM
    window.shadowElements = {}

    // shadow dom for header and footer
    jq('.client-content.needs-init').each(function () {
        const content = jq(this)[0];
        const contentRoot = content.attachShadow({ mode: 'open' });
        if (content.querySelector('header')) {
            window.shadowElements.header = contentRoot;
        } else {
            window.shadowElements.footer = contentRoot;
        }

        let shadowContent = '';
        shadowContent += content.innerHTML;
        contentRoot.innerHTML = shadowContent;
        content.innerHTML = '';

        const careerDropdownBtn = contentRoot?.querySelector('.career-dropdown-btn');
        if(careerDropdownBtn && careerDropdownBtn.nextElementSibling) {
            const careerDropdown = careerDropdownBtn.nextElementSibling;
            careerDropdownBtn.classList.add('transition-transform');
            
            const toggleDropdown = () => {
                careerDropdown.classList.toggle('hidden');
                careerDropdownBtn.classList.toggle('rotate-180');
                if(careerDropdown.classList.contains('hidden')) {
                    careerDropdownBtn.setAttribute('aria-expanded', 'false');
                } else {
                    careerDropdownBtn.setAttribute('aria-expanded', 'true');
                }
            }

            careerDropdownBtn.addEventListener('click', (evt) =>{
                evt.stopPropagation();
                toggleDropdown();
            });
            document.addEventListener('click', (e) => {
                // Check if click is outside both the button and dropdown
                if (!careerDropdownBtn.contains(e.target) && !careerDropdown.contains(e.target)) {
                    // Hide the dropdown if it's open
                    if (!careerDropdown.classList.contains('hidden')) {
                        careerDropdown.classList.add('hidden');
                        careerDropdownBtn.classList.remove('rotate-180');
                        careerDropdownBtn.setAttribute('aria-expanded', 'false');
                    }
                }
            });
        }

        const togglers = window.shadowElements?.footer?.querySelectorAll('.toggler');
        togglers?.forEach(toggler => {
            const dropdown = toggler.nextElementSibling;
            dropdown && toggler.addEventListener('click', () => {
                dropdown.classList.toggle('hidden');
                if(dropdown.classList.contains('hidden')) {
                    toggler.setAttribute('aria-expanded', 'false');
                } else {
                    toggler.setAttribute('aria-expanded', 'true');
                }
            });
        });

        const getNextAriaLevel = (level) => {
            if(level == 1) {
                return 1;
            }

            level--;
            const headings = Array.from(document.querySelectorAll(`h${level}`));

            const upperHeadingsEmpty = headings.length === 0 || headings.every(heading => window.getComputedStyle(heading).display === 'none');
            if(upperHeadingsEmpty) {
                return getNextAriaLevel(level);
            } 

            return level;
        }

        setTimeout(() => {
            content.classList.remove('needs-init');

            // adjust heading level on footer
            const level = getNextAriaLevel(4);
            window.shadowElements?.footer
                .querySelectorAll('h4')
                .forEach(h4 => h4.setAttribute('aria-level', level));
                
        }, 100);
    });

    let debounceTimer = null;

    window.addEventListener('resize', () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            const navContainer = window.shadowElements?.header?.querySelector('.nav-container');
            if(window.innerWidth < 1040) {
                navContainer.classList.remove('container');
            } else {
                navContainer.classList.add('container');
            }
        }, 200);
    });
});